export const CALENDAR_PROVIDERS = {
    GOOGLE_CALENDAR: {
        name: 'Google Calendar',
        icon: <img src="https://img.icons8.com/color/48/google-calendar--v2.png" alt="loader" width={48} height={48} />,
    },
    OUTLOOK_CALENDAR: {
        name: 'Outlook Calendar',
        icon: <img src="https://img.icons8.com/fluency/96/windows-calendar.png" alt="loader" width={48} height={48} />,
    },
};
